import Lottie from "lottie-react";

import animation from "../../../../assets/animation/MZKc7dDskN.json";

const FallbackLoader: React.FC = () => {
  return (
    <div className="loader">
      <Lottie
        animationData={animation}
        loop={true}
        autoPlay={true}
        style={{ width: 300, height: 300, overflow: "hidden" }}
      ></Lottie>
    </div>
  );
};

export default FallbackLoader;
